import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

import { showModal } from './b-modal';

var modalTemplate = '\
	<div class="b-modal">\
		<div class="b-modal-wrap">\
			<span class="b-modal-close i-modal-close"></span>\
			<div class="b-modal-dialog" id="vacancyInfo">\
			</div>\
		</div>\
	</div>\
';

var modal;
function getModal() {
	if (!modal) {
		var wrap = $('<div>');
		modal = $(modalTemplate).appendTo(wrap);
		wrap.execInit();
		modal.appendTo(document.body);
	}
	return modal;
}

$.addInit(function(context) {
	if (context === document) {

		function createModal(e) {
			e.preventDefault();
			var modal = getModal();
			var link = $(this);
			var content = link.data('text');
			var dialog = modal.find('.b-modal-dialog');
			dialog.html(content);
	
			showModal(modal);
	
			modal.on('close', function() {
				// dialog.html('');
				dialog.execInit()
			});
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				$(document).on('click', '.i-modal-vacancy', createModal);
			})
			.onmismatch(function() {
				$(document).off('click', '.i-modal-vacancy', createModal);
			});
	}
});
